import { useEffect, useState } from "react";

import ImageHoverPopup from "../../../../components/ImageHoverPopup";
import titleCaseString from "../../../../utils/titleCaseUtils";
import { getFileType } from "../../../../utils/fileTypeUtils";


/* PDF VIEWER */

import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { fullScreenPlugin } from "@react-pdf-viewer/full-screen";
import "@react-pdf-viewer/full-screen/lib/styles/index.css";

import Spinner from "../../../../components/Spinner";



const TabTransaction = ({selectedItem}) => {

    const fileType = getFileType(selectedItem.document_attachment);



      // PDF VIEWER
      const zoomPluginInstance = zoomPlugin();
      const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
    
    
      const fullScreenPluginInstance = fullScreenPlugin();
      const { EnterFullScreenButton } = fullScreenPluginInstance;


      const [pdfData, setPdfData] = useState(null);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);


    useEffect(() => {
        if (!selectedItem?.document_attachment) return;

        setLoading(true);
        setError(null);

        // Abort if component unmounts before fetch completes
        const controller = new AbortController();

        fetch(selectedItem.document_attachment, { signal: controller.signal })
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Failed to load PDF");
                }
                return res.blob();
            })
            .then((blob) => {
                const fileUrl = URL.createObjectURL(blob);
                setPdfData(fileUrl);
                setLoading(false);
            })
            .catch((err) => {
                if (err.name !== "AbortError") {
                    console.error("Error loading PDF:", err);
                    setError("Failed to load PDF");
                    setLoading(false);
                }
            });

        return () => {
            controller.abort(); // Cancel the fetch if the component unmounts
        };
    }, [selectedItem?.document_attachment]);






    const DateFormatter = ({ date }) => {
            const formatDate = (date) => {
            const options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            };
        
            // Format the date without the time
            return new Date(date).toLocaleDateString('en-US', options);
            };
        
            return <div>{formatDate(date)}</div>;
        };





    return (
    
              <div className="col-12 mb-md-0 mb-4">
                <div className="card shadow-none">
                  {/* PAGE 1 */}
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <table className="table table-bordered" style={{borderRadius:10}}>
                            <tr className="border">
                                <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">Document Info</th>
                            </tr>
                          <tbody>
                            <tr>
                              <td className="pe-3">
                                <i className="bx bx-book" /><span className="fw-medium mx-2">Document Name:</span>
                              </td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{selectedItem.document_name?.toUpperCase()==="TITLE YOUR DOCUMENT" ? selectedItem.document_title?.toUpperCase() : selectedItem.document_name?.toUpperCase()}</td>
                            </tr>
                            <tr>
                              <td className="pe-3"><i className="bx bx-book-open" /><span className="fw-medium mx-2">Document No:</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{selectedItem.document_no}</td>
                            </tr>
                            <tr>
                              <td className="pe-3"><i className="bx bx-bookmark-alt" /><span className="fw-medium mx-2">Page No:</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{selectedItem.page_no}</td>
                            </tr>
                            <tr>
                              <td className="pe-3"><i className="bx bx-book-open" /><span className="fw-medium mx-2">Book No:</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{selectedItem.book_no}</td>
                            </tr>
                            
                            <tr>
                            <td className="pe-3"><i className="bx bx-user" /><span className="fw-medium mx-2">Document For:</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{titleCaseString(selectedItem.document_for_whom?.toUpperCase())}</td>
                            </tr>
                            <tr>
                            <td className="pe-3"><i className="bx bx-group" /><span className="fw-medium mx-2">Relationship:</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{titleCaseString(selectedItem.relationship?.toUpperCase() ?? "")}</td>
                            </tr>



                            <tr className="border">
                                <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">Questions</th>
                            </tr>

                         
                            
                            <tr height={70}>
                              <td className="pe-3"><i className="bx bx-radio-circle-marked text-info" /><span className="fw-medium mx-2">Affiant is in the Philippines?</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{selectedItem.is_inside_philippines?.toLowerCase()}</td>
                            </tr>
                            <tr height={70}>
                              <td className="pe-3"><i className="bx bx-radio-circle-marked text-info" /><span className="fw-medium mx-2">Will the notarized document be used in the Philippines or abroad?</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{selectedItem.question_1?.toLowerCase()}</td>
                            </tr>
                            <tr height={70}>
                            <td className="pe-3"><i className="bx bx-radio-circle-marked text-info" /><span className="fw-medium mx-2">Is the document signed by all signatories by hand (wet-signed)?</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{selectedItem.question_2?.toLowerCase()}</td>
                            </tr>
                            
                            <tr height={70}>
                            <td className="pe-3"><i className="bx bx-radio-circle-marked text-info" /><span className="fw-medium mx-2">Were the signatories in the Philippines when they signed the document?</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{selectedItem.question_3?.toLowerCase()}</td>
                            </tr>
                            <tr height={70}>
                            <td className="pe-3"><i className="bx bx-radio-circle-marked text-info" /><span className="fw-medium mx-2">Are the signatories currently in the Philippines?</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{selectedItem.question_4?.toLowerCase()}</td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  

                  {/* PAGE 2 - Uploaded Documents / Requirements */}
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <table className="table table-bordered" style={{ borderRadius: 10 }}>
                          <tr className="border">
                            <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">Scanned & Uploaded Document(s)</th>
                          </tr>
                          <tbody>
                            <tr>
                              <td className="text-center">
                                <div style={{ overflowY: "auto" }}>
                                  {fileType === 'image' &&
                                    <img
                                      src={selectedItem.document_attachment}
                                      alt={`Uploaded file`}
                                      style={{ maxHeight: 350, objectFit: "cover" }}
                                    />
                                  }


                                  {loading && <div><Spinner color="primary" withborder={true}/></div>}
                                  {error && <div className="text-danger">{error}</div>}


                                  {pdfData && fileType === 'pdf' &&
                                    <div className="pdf-viewer" style={{ maxHeight: 350 }}>
                                      <Worker workerUrl="../js/pdf.worker.min.js">
                                        <div className="mb-2 d-flex col-12 justify-content-center p-0">
                                          <ZoomOutButton />
                                          <ZoomPopover />
                                          <ZoomInButton />
                                          <EnterFullScreenButton plugin={fullScreenPluginInstance} />

                                        </div>
                                        <Viewer fileUrl={pdfData}
                                          plugins={[zoomPluginInstance, fullScreenPluginInstance]}
                                        />
                                      </Worker>
                                    </div>
                                  }
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>

              
                </div>
              </div> 
     );
}
 
export default TabTransaction;